import script from "./MasterclassInput.vue?vue&type=script&setup=true&lang=js"
export * from "./MasterclassInput.vue?vue&type=script&setup=true&lang=js"

import "./MasterclassInput.vue?vue&type=style&index=0&id=f7b44a6a&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f7b44a6a"]])

export default __exports__